module.exports = __webpack_public_path__ + "static/media/school.37512b0f.jpg";